import { Component, OnInit } from '@angular/core';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit{
  private user!: UserProfileRecord;
  constructor(
    protected userService: UserService
  ) {}
  
  ngOnInit() {
    this.user = this.userService.profile;
  }

  get displayName() {
    return this.user?.displayName;
  }
}
